<template>
  <div>
    <Head :title="$t('models.user')"/>

    <h1 class="mb-8 text-3xl font-bold">{{ $t('models.user') }}</h1>

    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">{{ $t('fields.user.role') }}</label>
        <select v-model="form.role" class="form-select mt-1 w-full">
          <option :value="null"/>
          <option v-for="role in roles" :value="role.name">{{ role.name }}</option>
        </select>

        <label class="block mt-4 text-gray-700">{{ $t('ui.trashed') }}</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null"/>
          <option value="with">{{ $t('ui.with_trashed') }}</option>
          <option value="only">{{ $t('ui.only_trashed') }}</option>
        </select>
      </search-filter>

      <Link class="inline-block btn-indigo" :href="route('admin.users.create')">
        <span>{{ $t('ui.create') }}</span>
        <span class="hidden md:inline">{{ $t('models.user') }}</span>
      </Link>
    </div>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">{{ $t('fields.user.name') }}</th>
          <th class="pb-4 pt-6 px-6">{{ $t('fields.user.mobile') }}</th>
          <th class="pb-4 pt-6 px-6">{{ $t('fields.user.email') }}</th>
          <th class="pb-4 pt-6 px-6">{{ $t('fields.user.role') }}</th>
          <th class="w-px"></th>
        </tr>
        </thead>
        <tbody>

        <tr v-for="user in users" :key="user.uuid"
            class="hover:bg-gray-100 focus-within:bg-gray-100 cursor-pointer"
            @click="visit(route('admin.users.edit', user.uuid))">
          <td class="px-6 py-4 border-t">
            <div class="flex items-center">
              <icon v-if="user.deleted_at" name="trash"
                    class="flex-shrink-0 mr-2 w-3 h-3 fill-gray-400"/>
              {{ user.name }}
            </div>
          </td>
          <td class="px-6 py-4 border-t">
            <div class="flex items-center">
              {{ user.mobile }}
              <icon v-if="user.mobile_verified_at" name="check"
                    class="flex-shrink-0 ml-2 w-3 h-3 fill-green-700"/>
            </div>
          </td>
          <td class="px-6 py-4 border-t">
            <div class="flex items-center">
              {{ user.email }}
              <icon v-if="user.email_verified_at" name="check"
                    class="flex-shrink-0 ml-2 w-3 h-3 fill-green-700"/>
            </div>
          </td>
          <td class="px-6 py-4 border-t">
            {{ user.role_name }}
          </td>
          <td class="w-px border-t">
            <Link class="focus:text-indigo-500" :href="route('admin.users.edit', user.uuid)"
                  tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400"/>
            </Link>
          </td>
        </tr>
        <tr v-if="users.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">{{ $t('alerts.no_record_found') }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Layouts/Authenticated'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    users: Array,
    roles: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        role: this.filters.role,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(route('admin.users.index'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    visit(url) {
      this.$inertia.get(url)
    },
  },
}
</script>
